import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AddToBasketHandler from '@/b2c/shared/checkout/ui/AddToBasketHandler.vue';
import offersStore from '@/b2c/offers/offers.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOfferToBasket',
  props: {
    buttonText: null
  },
  setup(__props: any) {

const props = __props as {
    buttonText?: string;
}



const addToBasket = async() => {
    return offersStore.addToBasket();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AddToBasketHandler, _mergeProps(props, { handler: addToBasket }), null, 16))
}
}

})